import { type MetaDescriptor } from '@remix-run/node'

import {
  NATIVE_APP,
  nativeAppLinkBaseUrl,
} from '#app/constants/nativeApp.ts'

/**
 * Facebook / Meta App Links-style tags plus iOS “web app” hint, matching Enjoei’s head pattern.
 * @see https://developers.facebook.com/docs/applinks/metadata-reference
 */
export function appLinksMeta(): MetaDescriptor[] {
  const nativeUrl = nativeAppLinkBaseUrl()
  return [
    { property: 'al:ios:url', content: nativeUrl },
    { property: 'al:ios:app_store_id', content: NATIVE_APP.appStoreId },
    { property: 'al:ios:app_name', content: NATIVE_APP.displayName },
    { property: 'al:android:url', content: nativeUrl },
    { property: 'al:android:package', content: NATIVE_APP.androidPackage },
    { property: 'al:android:app_name', content: NATIVE_APP.displayName },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
  ]
}
